import { subscriptionClient } from '@/helpers/api/apiClients'
import type { ISubscriptionRepository } from './contracts/ISubscriptionRepository'
import { subscriptionTenantApi } from './subscriptionTenantApi'
import { downloadSqlDbd } from './sqlDbdDownloadApi'
import { paymentApi } from './paymentApi'

/**
 * Subscription service - abstraction over subscription API client.
 * Use this instead of importing subscriptionClient directly for better testability.
 */
export const subscriptionService: ISubscriptionRepository = {
	getAllSubscriptionDetails: () => subscriptionClient.getAllSubscriptionDetails(),
	getPublicSubscriptionPlans: () => subscriptionTenantApi.getPublicPlans(),
	getCurrentSubscriptionDetail: () => subscriptionTenantApi.getCurrentSubscriptionDetail(),
	getPaymentStatus: (transKey) => paymentApi.getPaymentStatus(transKey),
	createIntent: (request) => paymentApi.createIntent(request),
	cancelSubscription: (reason) => subscriptionTenantApi.cancelSubscription(reason),
	getLicenseDownload: () => subscriptionTenantApi.getLicense(),
	downloadSqlDbd: () => downloadSqlDbd(),
	renewSubscription: (planId) => subscriptionTenantApi.renew(planId),
}
